import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { FaSliders } from 'react-icons/fa6';

const TableHeader = () => {
  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto">
          <AdvanceTableSearchBox
            className="w-10"
            placeholder="Recherche par mot clé"
          />
        </Col>
        <Col xs="auto" className="pe-0">
          <Button
            variant="falcon-default"
            size="sm"
            transform="shrink-4"
            className="mx-2"
            // onClick={handleShow}
          >
            <FaSliders />
            <span className="d-none d-sm-inline-block ms-1">Filter</span>
          </Button>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <div
          className="bg-300 mx-3 d-none d-lg-block d-xl-none"
          style={{ width: '1px', height: '29px' }}
        ></div>
      </div>
    </div>
  );
};

export default TableHeader;
